import React, { memo, useEffect, useState, useRef } from 'react'
import CheckByPhoneModalStyle from '../CheckByPhoneModal/CheckByPhoneModalStyle'
import Modal from 'react-modal'
import { ErrorModal, SuccessModal } from '../index'
import _, { get } from 'lodash'
import api from '../../../api'
import { useTranslation } from 'react-i18next'
import { AutoComplete, Button, Spin, Tag } from 'antd'
import moment from 'moment'
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		maxHeight: '100vh',
		width: '85%',
	},
	overlay: {
		background: '#00000099',
	},
}

const AddPoliceOutgoingModal = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	phones = '',
	invoiceDate = '',
}) => {
	const { t } = useTranslation()

	const errorModalRef = useRef()
	const successRef = useRef()
	const inputRef = useRef(null)

	const [date, setDate] = useState(
		moment(invoiceDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
	)

	const errorRef = useRef()
	const [currency, setCurrency] = useState('USD')
	const [cashAccountsData, setCashAccountsData] = useState([])
	const [spendAccountsData, setSpendAccountsData] = useState([])
	const [formData, setFormData] = useState({
		CardCode: '',
		CashAccount: '',
		CashSum: 0,
		AccountCode: '',
		cashFlow: '7',
		CardName: '',
	})
	const [btnLoading, setBtnLoading] = useState(false)
	const [isOpenModal, setIsOpenModal] = useState(false)
	const [remarks, setRemarks] = useState(null)
	const [docEntry, setDocEntry] = useState('')
	const [userFields, setUserFields] = useState([])
	const [spendAccLoading, setSpenAccLoading] = useState(false)
	const [installment, setInstallment] = useState(-1)
	const [isAddonWord, setIsAddonWord] = useState('')
	const [loadingBusinessPartners, setLoadingBusinessPartners] = useState(false)
	const [businessPartnersData, setBusinessPartnersData] = useState([])
	const [cardName, setCardName] = useState('')
	const [cardCode, setCardCode] = useState('')

	useEffect(() => {
		const ref = {
			open: (t) => {
				setIsOpenModal(true)
				setDocEntry(t.docEntry)
				setInstallment(t.installment)
				typeSpend(t.installment, t.isAddonWord)
				setIsAddonWord(t.isAddonWord)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	useEffect(() => {
		getBusinessPartners()
	}, [])

	const handleSpendAccountClick = (event) => {
		if (inputRef.current) {
			inputRef.current.value = event.target.innerText
		}
		setFormData((prev) => ({
			...prev,
			CardCode: event.target.value,
		}))
	}

	const getBusinessPartners = async (name = '') => {
		const formattedName = name.includes("'") ? name.replace(/'/g, "''") : name

		setLoadingBusinessPartners(true)
		const data = await api(
			`BusinessPartners?$select=CardCode,CardName,GroupCode&$filter=CardType eq 'cSupplier' and GroupCode eq 105 and contains(CardName,'${formattedName}')`,
		).then((res) => {
			return JSON.parse(res.data).value
		})

		const selectElementData = data.map((item) => {
			return {
				value: item.CardCode,
				label: item.CardName,
			}
		})

		setBusinessPartnersData(selectElementData)
		setLoadingBusinessPartners(false)
	}

	const cashAccounts = async () => {
		const data = await api(`ChartOfAccounts?$select=Code,Name`, {
			headers: {
				Prefer: 'odata.maxpagesize=10000',
			},
		}).then((res) => {
			return JSON.parse(res.data).value
		})
		setCashAccountsData(data)
	}

	const userFieldsFn = () => {
		api
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'ORCT'",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}
	const typeSpend = async (installment, isAddonWord) => {
		const data = await api(
			`ChartOfAccounts?$select=Code,Name,U_Tarriff,ExternalCode&$filter=startswith(Code, '94') and ExternalCode eq '5' and (AcctCurrency eq '${currency}' or AcctCurrency eq '%23%23')and U_Tarriff le ${+installment - 1}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		)
			.then((res) => {
				return JSON.parse(res.data).value
			})
			.finally(() => {
				setSpenAccLoading(false)
			})
		if (data.length === 0) {
			errorModalRef.current?.open('Нет доступных счетов')
			setSpendAccountsData([])
			setFormData((prev) => ({
				...prev,
				CardCode: '',
			}))
			return
		} else if (isAddonWord === 'False') {
			console.log('isAddonWord Inside Else If', isAddonWord)
			const isZero = data.filter((item) => item.U_Tarriff == 0)
			console.log('isZero', isZero)
			setSpendAccountsData(isZero)
			setFormData((prev) => ({
				...prev,
				CardCode: '',
			}))
			return
		} else if (data.length === 1) {
			setSpendAccountsData(data)
			setFormData((prev) => ({
				...prev,
				CardCode: '',
			}))
		} else {
			const biggertarif = data.reduce((max, item) => {
				return item.U_Tarriff > max.U_Tarriff ? item : max
			})
			setSpendAccountsData([biggertarif])
			setFormData((prev) => ({
				...prev,
				CardCode: '',
			}))
		}
	}
	const submitForm = async () => {
		setBtnLoading(true)

		// {
		//     "DocType": "dDocument_Service", // o'zgarmidi
		//     "DocDate": "2025-07-30", // invoice sanasi
		//     "CardCode": "0000001", // militsa pastavshik
		//     "DocCurrency": "USD", // valyuta
		//     "DocumentLines": [
		//         {
		//             "AccountCode": "9410", // shot
		//             "UnitPrice": 400 // summa
		//         }
		//     ]
		// }

		const data = {
			DocDate: date,
			DocType: 'dDocument_Service',
			CardCode: cardCode,
			// CashAccount: formData.CashAccount,
			Comments: remarks ? remarks : null,
			DocCurrency: currency,
			// CashSum: formData.CashSum,
			// U_CashFlow: formData.cashFlow,
			U_Invoice: docEntry,
			// SupplierCode: "МЛ001",
			DocumentLines: [
				{
					AccountCode: formData.CardCode,
					UnitPrice: formData.CashSum,
				},
			],
		}

		console.log('data', data)

		try {
			await api.post('PurchaseInvoices', data).then((res) => {
				successRef.current?.open(t('sucessAdded'))
				resetForm()
			})
		} catch (err) {
			if (err) {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			}
		} finally {
			setBtnLoading(false)
		}
	}

	const handleDateChange = (event) => {
		setDate(event.target.value)
	}

	const handleCurrencyChange = (event) => {
		setCurrency(event.target.value)
		setSpendAccountsData([])
		setCashAccountsData([])
		if (inputRef.current) {
			inputRef.current.value = ''
		}
		setFormData((prev) => ({
			...prev,
			CashSum: null,
			CardCode: null,
		}))
	}

	const handleClickAccountCode = (event) => {
		setFormData((prev) => ({
			...prev,
			CashAccount: event.target.value,
		}))
	}

	const handleRemarks = (event) => {
		setRemarks(event.target.value)
	}

	const resetForm = () => {
		setDocEntry('')
		setRemarks('')
		setCurrency('USD')
		setCardName('')
		setCardCode('')
		setDate(new Date().toISOString().split('T')[0])
		setFormData({
			CardCode: '',
			CashAccount: '',
			CashSum: 0,
			AccountCode: '',
			cashFlow: '7',
		})
	}

	useEffect(() => {
		cashAccounts()
		userFieldsFn()
	}, [currency])

	useEffect(() => {
		typeSpend(installment, isAddonWord)
	}, [currency, installment])

	const handleBusinessPartner = _.debounce((val) => {
		getBusinessPartners(val)
	}, 1000)

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<CheckByPhoneModalStyle>
				<div className="container minWidthContainer">
					<p className="productTitle text-xl font-bold text-center py-8">
						{t('addPoliceExpense')}
					</p>

					<div>
						<div className="flex justify-center w-full px-4">
							<div className="w-full max-w-5xl">
								<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-6">
									{/* Поставщик */}
									<div className="flex flex-col gap-2 w-full">
										<p className="text-gray-800 font-medium text-sm">
											Поставщик
										</p>
										<AutoComplete
											options={businessPartnersData?.map((item) => ({
												value: `${item.value} ,/ ${item.label}`,
												label: (
													<div className="flex items-center justify-between">
														<span>{item.label}</span>
														<Tag color="blue">{item.value}</Tag>
													</div>
												),
												cardCode: item.value,
												cardName: item.label,
											}))}
											value={cardName}
											className="w-full"
											onSelect={(value, label) => {
												console.log(value, label)
												setCardName(label?.cardName)
												setCardCode(label?.cardCode)
												handleBusinessPartner('')
											}}
											loading={loadingBusinessPartners}
											onChange={(val) => {
												handleBusinessPartner(val)
												setCardName(val)
											}}
											showSearch
										/>
									</div>

									{/* Currency */}
									<div className="flex flex-col gap-2 w-full">
										<p className="font-medium text-zinc-600 text-sm">
											{' '}
											{t('currency')}{' '}
										</p>
										<select
											className="border border-[#DFE2E9] p-2 rounded-md w-full"
											value={currency}
											onChange={handleCurrencyChange}
										>
											<option value="USD">USD</option>
											<option value="UZS">UZS</option>
										</select>
									</div>

									{/* Expense Cash */}
									<div className="flex flex-col gap-2 w-full">
										<p className="font-medium text-zinc-600 text-sm">
											{t('expenseCash')}
										</p>
										<select
											value={formData.CardCode}
											className="border border-[#DFE2E9] p-2 rounded-md w-full"
											onChange={handleSpendAccountClick}
										>
											<option value=""></option>
											{spendAccountsData?.map((item) => (
												<option key={item.Code} value={item.Code}>
													{item.Name} - {item.Code}
												</option>
											))}
										</select>
									</div>

									{/* Date */}
									<div className="flex flex-col gap-2 w-full">
										<p className="font-medium text-zinc-600 text-sm">
											{t('date')}
										</p>
										<input
											className="border border-[#DFE2E9] p-2 rounded-md w-full"
											type="date"
											defaultValue={date}
											onChange={handleDateChange}
											disabled
										/>
									</div>

									{/* Price */}
									<div className="flex flex-col gap-2 w-full">
										<p className="font-medium text-zinc-600 text-sm">
											{t('price')}
										</p>
										<input
											className="border border-[#DFE2E9] p-2 rounded-md w-full"
											type="number"
											onChange={(e) =>
												setFormData((prev) => ({
													...prev,
													CashSum: parseFloat(e.target.value),
												}))
											}
											value={formData.CashSum}
										/>
									</div>

									{/* Comment */}
									<div className="flex flex-col gap-2 w-full">
										<p className="font-medium text-zinc-600 text-sm">
											{t('comment')}
										</p>
										<textarea
											className="border border-[#DFE2E9] p-2 rounded-md w-full min-h-[80px]"
											onChange={handleRemarks}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="flex justify-center py-4">
							<Button
								onClick={submitForm}
								loading={btnLoading}
								disabled={!formData.CardCode || !cardCode || !formData.CashSum}
								className="bg-blue-900 text-white h-10 hover:bg-blue-700"
							>
								{t('add2')}
							</Button>
						</div>
					</div>
				</div>

				<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
				<SuccessModal
					getRef={(r) => {
						successRef.current = r
					}}
					onConfirm={() => setIsOpenModal(false)}
				/>
			</CheckByPhoneModalStyle>
		</Modal>
	)
}

export default memo(AddPoliceOutgoingModal)
